// pages/Test.js
import Card from '../components/Card';

const Test = () => {
  return (
    <div className="page">
      <h1 className="title">オンラインテスト</h1>

      <Card title="オンラインテスト">
        <p>学習成果をその場で測定できるオンラインテストを用意。自動採点機能付きで復習にも最適です。</p>
        <div style={{ marginTop: '1rem' }}>
          <iframe
            src="https://curriculum-exam.myou-kou.com/"
            title="オンラインテスト"
            width="100%"
            height="800"
            style={{ border: '1px solid #ccc', borderRadius: '8px' }}
          ></iframe>
        </div>
      </Card>
    </div>
  );
};

export default Test;
